"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var AnimalIcon = function () {
    return (react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "15", height: "15.75", viewBox: "0 0 18 15.75" },
        react_1.default.createElement("g", { transform: "translate(431.402 -2621.108)" },
            react_1.default.createElement("path", { d: "M-428.771,2630.064a2.283,2.283,0,0,1-2.516-1.762,1.992,1.992,0,0,1,1.191-2.649,2.283,2.283,0,0,1,2.516,1.762A1.992,1.992,0,0,1-428.771,2630.064Zm13.119,4.835c0,1.227-.943,1.96-2.522,1.96-1.7,0-2.839-.881-4.228-.881s-2.511.881-4.228.881c-1.58,0-2.522-.733-2.522-1.96,0-2.724,3.958-7.04,6.75-7.04S-415.652,2632.174-415.652,2634.9Zm-11.672-10.459c-.416-1.527.128-3,1.216-3.282s2.307.719,2.723,2.246-.128,3-1.216,3.282S-426.908,2625.966-427.325,2624.439Zm5.906-1.037c.416-1.527,1.635-2.532,2.723-2.246s1.632,1.756,1.216,3.282-1.635,2.532-2.723,2.246S-421.835,2624.929-421.419,2623.4Zm7.9,4.9a2.284,2.284,0,0,1-2.516,1.762,1.992,1.992,0,0,1-1.191-2.649,2.283,2.283,0,0,1,2.516-1.762A1.992,1.992,0,0,1-413.518,2628.3Z", transform: "translate(0 0)", fill: "#fbaf29" }))));
};
exports.default = react_1.memo(AnimalIcon);
